// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".charge-points[data-v-5e2617ae]{padding:0 .75rem}.title[data-v-5e2617ae]{margin-bottom:0}.close[data-v-5e2617ae]{cursor:pointer;opacity:1}.close[data-v-5e2617ae]:before{content:\"\";font-size:1rem}.arrow-right--black[data-v-5e2617ae]{fill:#000;cursor:pointer;padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
